// ============================================================
// TMR Portal Admin — o que falta num cadastro, em português
// ============================================================
import type { RegistrationGap } from './contract';

/** What each gap is called on screen. The backend stores the key; the words are copy and live here. */
const GAP_LABEL: Record<RegistrationGap, string> = {
  Cnpj: 'CNPJ',
  Representative: 'Representante legal',
  Address: 'Endereço',
  LegalName: 'Razão social',
  SubdomainConflict: 'Domínio divergente do legado',
};

/**
 * The gaps that stop the Empresa reaching the legacy — mirrors `RegistrationGapRules.BlocksExport`.
 *
 * Duplicated here on purpose, and the duplication is asserted by a test: the screen has to be able to say
 * *why* an Empresa is not replicating without a round trip, and the two are different questions. A missing
 * razão social is worth showing and does not block anything; a missing CNPJ means no export can happen at
 * all.
 */
const BLOCKS_EXPORT: ReadonlySet<RegistrationGap> = new Set<RegistrationGap>([
  'Cnpj',
  'Representative',
  'Address',
]);

/**
 * What a gap is called, falling back to the raw key.
 *
 * The fallback is the normal case for a newer backend, not a bug: the two ship separately, and a key this
 * build never heard of must read as something rather than disappear from a list of what is missing.
 *
 * @param gap The key the backend sent.
 */
export function gapLabel(gap: RegistrationGap | string): string {
  return GAP_LABEL[gap as RegistrationGap] ?? gap;
}

/**
 * Whether any of these gaps stops the Empresa from being replicated to the legacy.
 *
 * @param gaps What the registration is missing.
 */
export function blocksExport(gaps: readonly (RegistrationGap | string)[]): boolean {
  return gaps.some((gap) => BLOCKS_EXPORT.has(gap as RegistrationGap));
}

/**
 * The one line the list badge shows: what is missing, in the operator's words.
 *
 * @param gaps What the registration is missing.
 */
export function gapSummary(gaps: readonly (RegistrationGap | string)[]): string {
  return gaps.map(gapLabel).join(', ');
}
